import { leadConstants } from '../constants';
import { AuthActions } from './'
import { LeadApi } from '../services';
import { redirect } from '../utils';

export class LeadActions {
    static getAllLeads () {
        return (dispatch) => {
            dispatch({type: leadConstants.GET_ALL_LEADS_REQUEST});

            LeadApi.getAllLeads()
                .then(AuthActions.ok(dispatch))
                .then((res) => {
                    // success
                    if(res.meta.success === true && res.data) {
                        dispatch({type: leadConstants.GET_ALL_LEADS_SUCCESS, payload: [...res.data]});
                        return;
                    }

                    return dispatch({type: leadConstants.GET_ALL_LEADS_FAILURE});
                })
                .catch((err) => {
                    dispatch({type: leadConstants.GET_ALL_LEADS_FAILURE});
                });
        }
    }

    static updateLead (leadID, data) {
        return (dispatch) => {
            dispatch({type: leadConstants.UPDATE_LEAD_REQUEST, payload: {leadID: leadID}});

            LeadApi.updateLead(leadID, data)
                .then(AuthActions.ok(dispatch))
                .then((res) => {
                    // success
                    if(res.meta.success === true && res.data) {
                        dispatch({type: leadConstants.UPDATE_LEAD_SUCCESS, payload: {...res.data}});
                        return;
                    }

                    return dispatch({type: leadConstants.UPDATE_LEAD_FAILURE, payload: {leadID: leadID}}); 
                })
                .catch((err) => {
                    dispatch({type: leadConstants.UPDATE_LEAD_FAILURE, payload: {leadID: leadID}}); 
                });
        }
    }

    static deleteLead (leadID) {
        return (dispatch) => {
            dispatch({type: leadConstants.DELETE_LEAD_REQUEST, payload: {leadID: leadID}});

            LeadApi.deleteLead(leadID)
                .then(AuthActions.ok(dispatch))
                .then((res) => {
                    // success
                    if(res.meta.success === true) {
                        dispatch({type: leadConstants.DELETE_LEAD_SUCCESS, payload: {leadID: leadID}});
                        redirect('/leads');
                        return;
                    }

                    return dispatch({type: leadConstants.DELETE_LEAD_FAILURE, payload: {leadID: leadID}}); 
                })
                .catch((err) => {
                    dispatch({type: leadConstants.DELETE_LEAD_FAILURE, payload: {leadID: leadID}}); 
                });
        }
    }
}


// WEBPACK FOOTER //
// ./src/actions/lead.js